@if (question().maxLength === 0 || mediaUploaded$().length < question().maxLength) {
  <div class="media__uploader">
    <eiq-file-uploader
      [acceptedTypesText]="acceptedTypeTexts$()"
      [acceptedTypes]="acceptedTypes$()"
      [maxSize]="maxSize$()"
      [multiple]="question().allowMultipleInd"
      [uploading]="uploading$()"
      (uploaded)="onUploadMedia($event)"
    ></eiq-file-uploader>
  </div>
}

@if (mediaUploaded$().length > 0) {
  <div class="media__container">
    @for (media of mediaUploaded$(); track media.id) {
      <div @mediaInserted class="media__content" [class.deleted]="media.deleted">
        @if (media.url$ | async; as url) {
          <button mat-icon-button title="Delete" class="media__delete-btn" color="warn" (click)="onDelete(media.id)">
            <fa-icon [icon]="faTrashCan"></fa-icon>
          </button>

          <empathy-media-view [mediaView]="media" [url]="url"></empathy-media-view>
        }
      </div>
    }
  </div>
}

@if (mediaFailed$().length > 0) {
  <div class="media__container">
    @for (media of mediaFailed$(); track media.id) {
      <div @mediaInserted class="media__content">
        <button mat-icon-button title="Discard" class="media__delete-btn" color="warn" (click)="onDeleteFailed(media.id)">
          <fa-icon [icon]="faTrashCan"></fa-icon>
        </button>

        <empathy-media-view [mediaView]="media" [url]="media.url"></empathy-media-view>
      </div>
    }
  </div>
}
